/**
 * Online Ordering Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OrderStatusEnum {

    Draft = 'draft',

    New = 'new',

    PendingPayment = 'pending_payment',

    PendingAcceptance = 'pending_acceptance',

    // Task 7 (order-queue-v2) — hand-added pending full OpenAPI regen. Order
    // exists but has not yet been claimed by the branch's POS (orderNumber
    // is still empty at this point).
    AwaitingPosConfirmation = 'awaiting_pos_confirmation',

    Confirmed = 'confirmed',

    Preparing = 'preparing',

    ReadyForPickup = 'ready_for_pickup',

    OutForDelivery = 'out_for_delivery',

    Delivered = 'delivered',

    Completed = 'completed',

    Cancelled = 'cancelled',

    Rejected = 'rejected'
}

